import { LOCATION_COMPONENTS_SEARCH_PARAMS } from "../locationConstants";

function checkIsLocationSearchMatch(currentSearch: string, compareSearch: string = '') {
    const currentSearchParams = new URLSearchParams(currentSearch);
    const compareSearchParams = new URLSearchParams(compareSearch);

    // check if current search params contain all compare search params
    for (const [compareKey, compareValue] of compareSearchParams) {
        if (currentSearchParams.get(compareKey) !== compareValue) {
            return false;
        }
    }

    // check if compare search params contain all current search params from const LOCATION_COMPONENTS_SEARCH_PARAMS
    for (const searchParamKey of Object.values(LOCATION_COMPONENTS_SEARCH_PARAMS)) {
        const currentSearchParamValue = currentSearchParams.get(searchParamKey);
        if (currentSearchParamValue && compareSearchParams.get(searchParamKey) !== currentSearchParamValue) {
            return false;
        }
    }

    return true;
}

export default checkIsLocationSearchMatch;
